import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationDemoComponent } from './notification-demo.component';

@NgModule({
    declarations: [
        NotificationDemoComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule
    ],
    exports: [
        NotificationDemoComponent
    ]
})
export class NotificationDemoModule { }